// Constants for media components

// Embed defaults
export const DEFAULT_EMBED_SIZE = 200;
export const DEFAULT_EMBED_WIDTH = 100;
export const DEFAULT_EMBED_HEIGHT = 100;

// Margin key mapping for CSS property conversion
export const MARGIN_KEY_MAPPING = {
  left: 'marginLeft',
  top: 'marginTop',
  bottom: 'marginBottom',
  right: 'marginRight',
} as const;

export const MARGIN_POSITIONS = ['left', 'top', 'bottom', 'right'] as const;
